
import dynamic from 'next/dynamic'
import parse from 'html-react-parser'

import Header from '../components/header'
import Link from 'next/link'
const Footer = dynamic(() => import('../components/footer'))
import TeamMembers from '../components/about/teammembers'
import Noresults from '../components/noresults';
const MiniCart = dynamic(() => import('../components/cart/minicart'))
import Scripts from '../components/scripts';
import MetaTags from '../components/MetaTags'

function AboutPage({ item, menu, config, list }) {

    return (
        <>
            <MetaTags item={item} config={config}></MetaTags>
            <div className="wrapper h-full flex flex-col">
                
                <Header menu={menu} config={config}></Header>

            
                <div className="hidden lg:block container mx-auto text-xs py-2 px-5 lg:px-0">
                    <div className="space-x-2 flex items-center leading-none">
                    <Link href="/">
                                <a title="Home">
                                    <i className="fas fa-home text-brand-tertiary"></i>
                                </a>
                            </Link>
                            <span className="text-gray-400">/</span>
                            <span className="text-gray-600">About Us</span>
                    </div>
                </div>


                <div className="pt-8 lg:pt-16">
                    {(item && item.description) ? (
                        parse(item.description)
                    ) : (
                        <Noresults></Noresults>
                    )}
                    {/* <TeamMembers list={list}></TeamMembers> */}
                </div>

                <Footer menu={menu} config={config}></Footer>

            </div>
            <MiniCart></MiniCart>
            <Scripts javascripts={item.javascripts}></Scripts>
        </>
    )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
    const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
    const config_data = await config_res.json()
    const config = config_data.data

    const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
    const menu = await menu_res.json()

    const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/about')
    const response = await res.json()
    const page = response.data

    const list_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/teammembers')
    const list_response = await list_res.json()
    const list = list_response.data



    return {
        props: {
            config: config,
            menu: menu,
            item: page,
            list: list,
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
            revalidate: 600, // In seconds
    
    }
}


export default AboutPage